import { render, staticRenderFns } from "./CurriculumUnitBlock.vue?vue&type=template&id=3cd866a3"
import script from "./CurriculumUnitBlock.vue?vue&type=script&lang=js"
export * from "./CurriculumUnitBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports